import Instance from '../../../../Axios';

// New Actions for the app

const GetItensTooltip = () => async (dispatch) => {
  await Instance()
    .get(`/backend/checklist/tooltip/checklistItens`)
    .then(({ data }) => {
      console.log(data);
      dispatch({ type: 'GET_ITENS_LIMPEZA', payload: data.yData });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetItensTooltip;
